import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CardSharedComponent } from './card.component';

import { ListSharedModule } from './../../atoms/list/list.module';
import { BadgeSharedModule } from './../../atoms/badge/badge.module';
import { ImageSharedModule } from './../../atoms/image/image.module';
import { FaIconSharedModule } from './../../atoms/fa.icon/fa.icon.module';
import { IconNavSharedModule } from './../../molecules/icon.nav/icon.nav.module';
import { AddToCalendarSharedModule } from './../../molecules/add.to.calendar/add.to.calendar.module';

import { ArrayService } from './../../../shared/service/array/array.service';

@NgModule({
    declarations: [
        CardSharedComponent
    ],
    imports: [
        CommonModule,
        ListSharedModule,
        ImageSharedModule,
        BadgeSharedModule,
        FaIconSharedModule,
        IconNavSharedModule,
        AddToCalendarSharedModule,
        RouterModule.forChild([])
    ],
    exports: [
        CardSharedComponent
    ],
    providers: [
        ArrayService
    ]
})

export class CardSharedModule {}
